import { usePlaidLink } from "react-plaid-link";

const usePlaid = ({
  token,
  onSuccess,
}: {
  token?: string;
  onSuccess: (_: { publicToken: string; metadata: any }) => void;
}) => {
  const { open: openPlaid, ready } = usePlaidLink({
    token: token || null,
    onSuccess: (publicToken, metadata) => {
      onSuccess({ publicToken, metadata });
    },
  });

  const open = () => {
    openPlaid();
  };

  return { open, ready };
};

export default usePlaid;
